import { Component, Input, OnInit } from '@angular/core';

import {
  ICONS_ENUM,
  OpenInsuranceIcons
} from '@app/open-insurance/shared/constants/icons';

@Component({
  selector: 'app-opin-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false
})
export class OpinIconComponent implements OnInit {
  ICONS: Record<OpenInsuranceIcons, string> = ICONS_ENUM;
  iconExists: boolean;

  @Input() size = 24;
  @Input() color: string;
  @Input() icon: OpenInsuranceIcons;

  ngOnInit(): void {
    try {
      this.iconExists = !!this.ICONS[this.icon];
    } catch {
      this.iconExists = false;
    }
  }
}
